module.exports = __webpack_public_path__ + "img/37.2fe49fae.jpg";